import { createReducer, on } from '@ngrx/store';
import { callApi, callApiSuccess, callApiFailure } from './actions';

export interface ApiState {
  loading: boolean;
  error: any;
  data: { [key: string]: any };
}

const initialState: ApiState = {
  loading: false,
  error: null,
  data: {},
};

export const apiReducer = createReducer(
  initialState,

  on(callApi, (state) => ({ ...state, loading: true, error: null })),

  on(callApiSuccess, (state, { key, data }) => ({
    ...state,
    loading: false,
    error: null,
    data: { ...state.data, [key]: data },
  })),

  on(callApiFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
